import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Table } from "antd";
import formatError from "../../services/FormatError";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import { sortList } from "./Users";
import { dateFormatter } from "./BuyerProfile";
import swal from "sweetalert";
import {
  addProfProfile,
  deleteProfessionalProfile,
  fetchAllProfessionals,
  fetchProfessionalDetails,
} from "../../services/ProfessionalService";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";
import config from "../../config";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];

const otherInterest = [
  {
    label: "Volunteering member",
    children: [],
  },
  {
    label: "Professional association member",
    children: [],
  },
  {
    label: "Politics",
    children: [],
  },
  {
    label: "Sports",
    children: [
      {
        label: "Basket-ball",
        value: "Basket-ball",
      },
      {
        label: "Football",
        value: "Football",
      },
      {
        label: "Soccer",
        value: "Soccer",
      },
      {
        label: "Baseball",
        value: "Baseball",
      },
      {
        label: "Golf",
        value: "Golf",
      },
      {
        label: "Tennis",
        value: "Tennis",
      },
    ],
  },
  {
    label: "Outooring  activities",
    children: [
      {
        label: "Kayak",
        value: "Kayak",
      },
      {
        label: "Biking",
        value: "Biking",
      },
      {
        label: "Hicking",
        value: "Hicking",
      },
      {
        label: "Alpine ski",
        value: "Alpine ski",
      },
      {
        label: "Crosscountry ski",
        value: "Crosscountry ski",
      },
    ],
  },
  {
    label: "Theater - Movies",
    children: [
      {
        label: "Drama",
        value: "Drama",
      },
      {
        label: "Suspense",
        value: "Suspense",
      },
      {
        label: "Horror",
        value: "Horror",
      },
      {
        label: "Comedy",
        value: "Comedy",
      },
    ],
  },
  {
    label: "Dance",
    children: [
      {
        label: "Hip Hop",
        value: "Hip Hop",
      },
      {
        label: "Latin",
        value: "Latin",
      },
      {
        label: "Social",
        value: "Social",
      },
      {
        label: "Disco",
        value: "Disco",
      },
      {
        label: "Ballet",
        value: "Ballet",
      },
    ],
  },
];
function ProfessionalProfile() {
  const { t } = useTranslation();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: config.googleMapsApiKey,
    libraries,
  });
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

  const role = userDetails?.result;

  const state = useSelector((state) => state.auth.auth.result);

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();

  const [profProfiles, setProfProfiles] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, setGridFilter] = useState("");

  const [addProf, setAddProf] = useState(false);

  const [triggered, setTriggered] = useState(false);

  const [isIterestItemsShow, setIsIterestItemsShow] = useState(false);
  const [subInterest, setSubInterest] = useState([]);
  const [selectedOtherInterest, setSelectedOtherInterest] = useState("");
  const [selectedSubInterest, setSelectedSubInterest] = useState([]);
  const [profDetails, setProfDetails] = useState({
    profilepicture: null,
    firstname: "",
    lastname: "",
    username: "",
    phone: "",
    address: "",
    email: "",
    city: "",
    country: "",
    profession: "",
    professionalProfileName: "",
    professionalProfileDomain: "",
    professionalProfilePhone: "",
    professionalProfilePhone2: "",
    professionalProfileFax: "",
    professionalProfileEmail: "",
    occupation: "",
    startService: "",
    website: "",
    postedDate: "",
    contactName: "",
    contactEmail: "",
    professionalProfileAddress: "",
    professionalProfileCity: "",
    professionalProfileRegion: "",
    professionalProfileCountry: "",
    professionalProfilePostalCode: "",
    professionalProfilePostalCode2: "",
  });

  
  // address autocomplete 
  const searchBoxRef = useRef(null);
  const searchBoxRefProf = useRef(null);


  // const [addressInput, setAddressInput] = useState(buyerDetails?.address || "");

    const handlePlacesChanged = () => {
      console.log(searchBoxRef.current,"adresse")
     if (!searchBoxRef.current) return; // 

      updateProfDetails("address", "");
      updateProfDetails("city", "");
      updateProfDetails("region", "");
      updateProfDetails("postalCode", "");
      updateProfDetails("country", "");

    const places = searchBoxRef.current.getPlaces();
    if (places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      let address  = "";
      let streetNumber="";
      let route ="";
      let city = "";
      let region = "";
      let postalCode = "";
      let country = "";

      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("street_number")) {
          address = component.long_name ;
        }
        if (types.includes("route")) {
          address = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          region = component.long_name;
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      });
      console.log(address,"adresse")

      updateProfDetails("address", address); // met à jour le state global

    //  updateBusinessDetails("address", address);
      updateProfDetails("city", city);
      updateProfDetails("region", region);
      updateProfDetails("postalCode", postalCode);
      updateProfDetails("country", country);
    }
  };
// End address autocomplete
   const handlePlacesChangedProf = () => {
      console.log(searchBoxRefProf.current,"adresse")
     if (!searchBoxRefProf.current) return; // 

      updateProfDetails("professionalProfileCity", "");
      updateProfDetails("professionalProfileRegion", "");
      updateProfDetails("professionalProfilePostalCode", "");
      updateProfDetails("professionalProfileCountry", "");

    const places = searchBoxRefProf.current.getPlaces();
    if (places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      let address  = "";
      let streetNumber="";
      let route ="";
      let city = "";
      let region = "";
      let postalCode = "";
      let country = "";

      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("street_number")) {
          address = component.long_name ;
        }
        if (types.includes("route")) {
          address = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          region = component.long_name;
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      });
      console.log(address,"adresse")


      updateProfDetails("professionalProfileAddress", address);
      updateProfDetails("professionalProfileCity", city);
      updateProfDetails("professionalProfileRegion", region);
      updateProfDetails("professionalProfilePostalCode", postalCode);
      updateProfDetails("professionalProfileCountry", country);
    }
  };
// End address autocomplete

  const [updateProf, setUpdateProf] = useState({
    cond: false,
    id: null,
  });

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    if (location?.state === true) {
      onCreateProf();
    }
  }, [location?.state]);

  useEffect(() => {
    fetchAllProfProfiles();
  }, [state, tableParams.current, tableParams.pageSize]);

  const fetchAllProfProfiles = () => {
    if (role?.role?.id !== 3) {
      // console.log("role id -------------", role?.role?.id);
      fetchAllProfessionals(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const sortedList = sortList(response?.data ?? []);

          setProfProfiles({
            original: [...sortedList],
            filtered: [...sortedList],
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      if (role?.user?.professional?.id === 0) {
        console.log("role id -------------", role?.user?.professional?.id);
        setProfProfiles({
          original: [],
          filtered: [],
        });
      } else {
        const professionalID = role?.user?.professional?.id ?? null;
        console.log("professionalID", professionalID);
        if (professionalID) {
          fetchProfessionalDetails(role?.user?.professional?.id)
            .then((res) => {
              const data = res.data?.result;
              console.table("data---", data);
              setProfProfiles({
                original: [data],
                filtered: [data],
              });
            })
            .catch((error) => {
              formatError(error?.response?.data?.error);
            });
        }
      }

      setTableParams((prevTableParams) => ({
        ...prevTableParams,
        total: 1,
      }));
    }
  };

  const updateGridData = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const filteredData = profProfiles.original.filter(
        (item) =>
          item?.professionalProfileName
            ?.toLowerCase()
            .includes(value.toLowerCase()) ||
          item?.firstname?.toLowerCase().includes(value.toLowerCase()) ||
          item?.lastname?.toLowerCase().includes(value.toLowerCase())
      );

      setProfProfiles((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setProfProfiles((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const onCreateProf = () => {
    setAddProf(true);
    setUpdateProf({
      cond: false,
      id: role.user?.professional?.id,
    });
    setProfDetails({
      profilepicture: null,
      firstname: "",
      lastname: "",
      username: "",
      phone: "",
      address: "",
      email: "",
      city: "",
      country: "",
      profession: "",
      professionalProfileName: "",
      professionalProfileDomain: "",
      professionalProfilePhone: "",
      professionalProfilePhone2: "",
      professionalProfileFax: "",
      professionalProfileEmail: "",
      occupation: "",
      startService: "",
      website: "",
      postedDate: new Date().toISOString().split("T")[0],
      contactName: "",
      contactEmail: "",
      professionalProfileAddress: "",
      professionalProfileCity: "",
      professionalProfileRegion: "",
      professionalProfileCountry: "",
      professionalProfilePostalCode: "",
      professionalProfilePostalCode2: "",
    });
  };

  const updateProfDetails = (key, value) => {
    setProfDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setProfDetails((prevState) => ({
      ...prevState,
      profilepicture: file,
    }));
  };

  const validateProfessionalProfile = (details) => {
    const requiredFields = [
      "firstname",
      "lastname",
      "username",
      "phone",
      "address",
      "email",
      "city",
      "country",
      "profession",
      "professionalProfileName",
      "professionalProfileDomain",
      "professionalProfilePhone",
      "professionalProfileEmail",
      "occupation",
      "contactName",
      "contactEmail",
      "profilepicture",
    ];

    for (let field of requiredFields) {
      if (!details[field]) {
        return true; // Has validation errors
      }
    }
    return false; // No validation errors
  };

  const addProfHandler = (id) => {
    console.log(selectedSubInterest, "subInterest");
    if (validateProfessionalProfile(profDetails)) {
      setTriggered(true);
    } else {
      setTriggered(false);

      // Create FormData for file upload
      const formData = new FormData();

      // Append all form fields to FormData
      Object.keys(profDetails).forEach((key) => {
        if (profDetails[key] !== null && profDetails[key] !== "") {
          formData.append(key, profDetails[key]);
        }
      });
      formData.append("otherinterests", String(selectedOtherInterest || ""));
      // Append sub-interests as a JSON string
      if (selectedSubInterest && selectedSubInterest.length > 0) {
        const subInterestsArray = selectedSubInterest.map(
          (item) => item.label || ""
        );
        formData.append("subinterests", JSON.stringify(subInterestsArray));
      } else {
        formData.append("subinterests", JSON.stringify([]));
      }

      addProfProfile(formData, id)
        .then((res) => {
          setProfDetails({
            profilepicture: null,
            firstname: "",
            lastname: "",
            username: "",
            phone: "",
            address: "",
            email: "",
            city: "",
            country: "",
            otherinterests: "",
            subinterests: "",
            profession: "",
            professionalProfileName: "",
            professionalProfileDomain: "",
            professionalProfilePhone: "",
            professionalProfilePhone2: "",
            professionalProfileFax: "",
            professionalProfileEmail: "",
            occupation: "",
            startService: "",
            website: "",
            postedDate: "",
            contactName: "",
            contactEmail: "",
            professionalProfileAddress: "",
            professionalProfileCity: "",
            professionalProfileRegion: "",
            professionalProfileCountry: "",
            professionalProfilePostalCode: "",
            professionalProfilePostalCode2: "",
          });

          if (updateProf.cond) {
            setUpdateProf({
              cond: false,
              id: null,
            });
          }

          setAddProf(false);

          const newSessionDetails = { ...userDetails };

          newSessionDetails.result.user.professional = res?.data?.result;

          sessionStorage.setItem(
            "userDetails",
            JSON.stringify(newSessionDetails)
          );

          dispatch(loginConfirmedAction(newSessionDetails));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };
  const onInterestChangeHandler = (e) => {
    if (e.target.value !== "") {
      setSelectedOtherInterest(e.target.value);
      const result = otherInterest.find(
        (item) => item.label === e.target.value
      );
      if (result.children?.length !== 0) {
        setSubInterest(result.children);
        setIsIterestItemsShow(true);
      } else {
        setSelectedSubInterest([]);
        setSubInterest([]);
        setIsIterestItemsShow(false);
      }
    }
  };
  const onBackCreate = () => {
    setAddProf(false);

    setProfDetails({
      profilepicture: null,
      firstname: "",
      lastname: "",
      username: "",
      phone: "",
      address: "",
      email: "",
      city: "",
      country: "",
      profession: "",
      professionalProfileName: "",
      professionalProfileDomain: "",
      professionalProfilePhone: "",
      professionalProfilePhone2: "",
      professionalProfileFax: "",
      professionalProfileEmail: "",
      occupation: "",
      startService: "",
      website: "",
      postedDate: "",
      contactName: "",
      contactEmail: "",
      professionalProfileAddress: "",
      professionalProfileCity: "",
      professionalProfileRegion: "",
      professionalProfileCountry: "",
      professionalProfilePostalCode: "",
      professionalProfilePostalCode2: "",
    });
  };

  const onViewProf = (id) => {
    navigate(`/professional/${id}`);
  };

  const onUpdateProf = (id) => {
    fetchProfessionalDetails(id)
      .then((res) => {
        const data = res.data?.result;
        console.log("dddddddddddddddddddddddddddd", data);
        setUpdateProf({
          cond: true,
          id: data?.id,
        });

        setAddProf(true);

        setProfDetails({
          profilepicture: null, // File will need to be re-selected
          firstname: data?.firstname || "",
          lastname: data?.lastname || "",
          username: data?.username || "",
          phone: data?.phone || "",
          address: data?.address || "",
          email: data?.email || "",
          city: data?.city || "",
          country: data?.country || "",
          otherinterests: data?.otherinterests || "",
          subinterests: data?.subinterests || "",
          profession: data?.profession || "",
          professionalProfileName: data?.professionalProfileName || "",
          professionalProfileDomain: data?.professionalProfileDomain || "",
          professionalProfilePhone: data?.professionalProfilePhone || "",
          professionalProfilePhone2: data?.professionalProfilePhone2 || "",
          professionalProfileFax: data?.professionalProfileFax || "",
          professionalProfileEmail: data?.professionalProfileEmail || "",
          occupation: data?.occupation || "",
          startService: data?.startService || "",
          website: data?.website || "",
          postedDate: data?.postedDate || "",
          contactName: data?.contactName || "",
          contactEmail: data?.contactEmail || "",
          professionalProfileAddress: data?.professionalProfileAddress || "",
          professionalProfileCity: data?.professionalProfileCity || "",
          professionalProfileRegion: data?.professionalProfileRegion || "",
          professionalProfileCountry: data?.professionalProfileCountry || "",
          professionalProfilePostalCode:
            data?.professionalProfilePostalCode || "",
          professionalProfilePostalCode2:
            data?.professionalProfilePostalCode2 || "",
        });
      })
      .catch((error) => {
        formatError(error?.response?.data?.error);
      });
  };

  const onDeleteProf = (id) => {
    swal({
      title: t("are_you_sure"),
      text: t("confirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteProfessionalProfile(id)
          .then((res) => {
            swal(t("hsuppressionsuccess"), "", "success");
            fetchAllProfProfiles();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const columns = [
    {
      title: `${t(`professionalProfileCulumn1`)}`,
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t(`professionalProfileCulumn2`)}`,
      dataIndex: "professionalProfileName",
      sorter: true,
      render: (text, record) => {
        return (
          <>
            <span>{text || `${record?.name}`}</span>
            <br />
            <span>{record?.contactEmail || record?.email}</span>
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t(`professionalProfileCulumn3`)}`,
      dataIndex: "professionalProfileCountry",
      width: "20%",
    },
    {
      title: `${t(`professionalProfileCulumn4`)}`,
      dataIndex: "createdat",
      render: (text) => dateFormatter(text),
      width: "20%",
    },
    {
      title: `${t(`professionalProfileCulumn5`)}`,
      dataIndex: "domain",
      width: "20%",
    },
    {
      title: `${t(`professionalProfileCulumn6`)}`,
      dataIndex: "occupation",
      width: "20%",
    },
    {
      title: `${t(`professionalProfileCulumn7`)}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              style={{ fontSize: "15px", marginRight: "8px" }}
              onClick={() => onViewProf(record?.id)}
            >
              <i className="fa fa-eye"></i>
            </a>
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              onClick={() => onUpdateProf(record?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            {(role?.role?.id === 1 || role?.role?.id === 2) && (
              <a
                href="javascript:void(0);"
                class="ms-2 btn btn-xs px-2 light btn-danger"
                style={{ marginRight: "8px" }}
                onClick={() => onDeleteProf(record?.id)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 6H5H21"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </a>
            )}
          </div>
        );
      },
      width: "20%",
    },
  ];

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  console.log(role);
   if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <div class="card">
        <div class="card-header d-sm-flex d-block">
          {addProf ? (
            <div class="d-flex me-auto mb-sm-0">
              <span
                style={{ fontSize: "18px", cursor: "pointer" }}
                className="d-flex justify-content-start align-items-center me-3"
                onClick={onBackCreate}
              >
                <i className="fa fa-arrow-left"></i>
              </span>
              <h4 class="card-title text-uppercase">
                {updateProf?.cond ? t("update") : t("globalCreateButton")}{" "}
                {t("sidebarItemProfessionalProfile")}
              </h4>
            </div>
          ) : (
            <>
              <div class="d-flex me-auto mb-sm-0">
                <h4 class="card-title">
                  {t("sidebarItemProfessionalProfile")}
                  {role?.role?.id !== 3 ? "S" : ""}
                </h4>
              </div>
              <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
              {role?.role?.id === 2 && (
                <div style={{ paddingLeft: "12px" }}>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-info"
                    onClick={onCreateProf}
                  >
                    + {t("professionalProfileCreateButton")}
                  </a>
                </div>
              )}
            </>
          )}
        </div>

        {!addProf && (
          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={profProfiles.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        )}
      </div>

      {addProf && (
        <div className="row">
          {/* First Name */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.firstname === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("signUpFirstnameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="First Name"
                className="form-control"
                value={profDetails?.firstname}
                onChange={(e) => updateProfDetails("firstname", e.target.value)}
              />
            </div>
            {triggered && profDetails?.firstname === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("signUpFirstnameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Last Name */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.lastname === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("signUpLastnameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="Last Name"
                className="form-control"
                value={profDetails?.lastname}
                onChange={(e) => updateProfDetails("lastname", e.target.value)}
              />
            </div>
            {triggered && profDetails?.lastname === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("signUpLastnameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          {/* Email */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.email === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("signUpEmailInput")}</strong>
              </label>
              <input
                type="email"
                placeholder="Email"
                className="form-control"
                value={profDetails?.email}
                onChange={(e) => updateProfDetails("email", e.target.value)}
              />
            </div>
            {triggered && profDetails?.email === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("signUpEmailInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          {/* Username */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.username === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("signUpUsernameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="Username"
                className="form-control"
                value={profDetails?.username}
                onChange={(e) => updateProfDetails("username", e.target.value)}
              />
            </div>
            {triggered && profDetails?.username === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("signUpUsernameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Phone */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.phone === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("signUpPhoneInput")}</strong>
              </label>
              <input
                type="tel"
                placeholder="Phone"
                className="form-control"
                value={profDetails?.phone}
                onChange={(e) => updateProfDetails("phone", e.target.value)}
              />
            </div>
            {triggered && profDetails?.phone === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("signUpPhoneInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Address */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.address === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("signUpAddressInput")}</strong>
              </label>
              <StandaloneSearchBox onLoad={(ref) => (searchBoxRef.current = ref)} onPlacesChanged={handlePlacesChanged}>

                <input
                  type="text"
                  placeholder="Address"
                  className="form-control"
                  value={profDetails?.address}
                  onChange={(e) => {
                    updateProfDetails("address",  e.target.value);
                    updateProfDetails("city", "");
                    updateProfDetails("region", "");
                    updateProfDetails("postalCode", "");
                    updateProfDetails("country", "");
                  }
                }
                  // value={profDetails?.address}
                  // onChange={(e) => updateProfDetails("address", e.target.value)}
                />
              </StandaloneSearchBox>
            </div>
            {triggered && profDetails?.address === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("signUpAddressInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Profile Picture */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                {" "}
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("photoInput")}</strong>
              </label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={handleFileChange}
              />
            </div>{" "}
            {triggered && profDetails?.profilepicture === null && (
              <div className="text-danger fs-12 mb-3">
                {t("photoInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* City */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.city === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("cityInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="City"
                className="form-control"
                value={profDetails?.city}
                onChange={(e) => updateProfDetails("city", e.target.value)}
              />
            </div>
            {triggered && profDetails?.city === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("cityInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Country */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.country === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("countryInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="Country"
                className="form-control"
                value={profDetails?.country}
                onChange={(e) => updateProfDetails("country", e.target.value)}
              />
            </div>
            {triggered && profDetails?.country === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("countryInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Other Interests */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hotherInterests")}</strong>
              </label>
              <select
                className="form-control"
                style={{ border: "1px solid #EEEEEE" }}
                onChange={onInterestChangeHandler}
              >
                <option value="">{t("globalSelect")}</option>
                {otherInterest?.map((item, index) => (
                  <option value={item.label} key={index}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Sub Interests */}
          {isIterestItemsShow && (
            <div className="col-md-12 col-lg-6 col-xl-4">
              <div className="form-group mb-3">
                <label className="mb-1">
                  <strong>{t("harea")}</strong>
                </label>
                <MultiSelect
                  hasSelectAll={false}
                  disableSearch={false}
                  options={subInterest}
                  value={selectedSubInterest}
                  onChange={setSelectedSubInterest}
                  labelledBy="Select"
                />
              </div>
            </div>
          )}

          {/* Profession */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.profession === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>Profession</strong>
              </label>
              <select
                className="form-control"
                style={{ border: "1px solid #EEEEEE" }}
                value={profDetails?.profession}
                onChange={(e) =>
                  updateProfDetails("profession", e.target.value)
                }
              >
                <option value="">{t("globalSelect")}</option>
                <option value="Real Estate Broker">{t("hbroker")}</option>
                <option value="Finance Broker">{t("hbrokerFinance")}</option>
                <option value="Lawyer">{t("hlawyer")}</option>
                <option value="Fiscalist">{t("hfiscaliste")}</option>
              </select>
            </div>
            {triggered && profDetails?.profession === "" && (
              <div className="text-danger fs-12 mb-3">
                Profession {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Professional Profile Name */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.professionalProfileName === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("hprofessionalProfile")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Name"
                className="form-control"
                value={profDetails?.professionalProfileName}
                onChange={(e) =>
                  updateProfDetails("professionalProfileName", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.professionalProfileName === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("hprofessionalProfile")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Professional Profile Domain */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.professionalProfileDomain === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("hprofessionaldomain")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Domain"
                className="form-control"
                value={profDetails?.professionalProfileDomain}
                onChange={(e) =>
                  updateProfDetails("professionalProfileDomain", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.professionalProfileDomain === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("hprofessionaldomain")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Professional Profile Phone */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.professionalProfilePhone === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("hprofessionalPhone")}</strong>
              </label>
              <input
                type="tel"
                placeholder="Professional Profile Phone"
                className="form-control"
                value={profDetails?.professionalProfilePhone}
                onChange={(e) =>
                  updateProfDetails("professionalProfilePhone", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.professionalProfilePhone === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("hprofessionalPhone")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Professional Profile Phone 2 */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalPhone")} 2</strong>
              </label>
              <input
                type="tel"
                placeholder="Professional Profile Phone 2"
                className="form-control"
                value={profDetails?.professionalProfilePhone2}
                onChange={(e) =>
                  updateProfDetails("professionalProfilePhone2", e.target.value)
                }
              />
            </div>
          </div>

          {/* Professional Profile Fax */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalFax")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Fax"
                className="form-control"
                value={profDetails?.professionalProfileFax}
                onChange={(e) =>
                  updateProfDetails("professionalProfileFax", e.target.value)
                }
              />
            </div>
          </div>

          {/* Professional Profile Email */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.professionalProfileEmail === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("hprofessionalEmail")}</strong>
              </label>
              <input
                type="email"
                placeholder="Professional Profile Email"
                className="form-control"
                value={profDetails?.professionalProfileEmail}
                onChange={(e) =>
                  updateProfDetails("professionalProfileEmail", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.professionalProfileEmail === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("hprofessionalEmail")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Occupation */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.occupation === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("occupationInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="Occupation"
                className="form-control"
                value={profDetails?.occupation}
                onChange={(e) =>
                  updateProfDetails("occupation", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.occupation === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("occupationInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Start Service */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("startServiceInput")}</strong>
              </label>
              <input
                type="date"
                className="form-control"
                value={profDetails?.startService}
                onChange={(e) =>
                  updateProfDetails("startService", e.target.value)
                }
              />
            </div>
          </div>
          {/* Start Service */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("buyerDetailsPostedDate")}</strong>
              </label>
              <input
                type="date"
                className="form-control"
                value={profDetails?.postedDate}
                onChange={(e) =>
                  updateProfDetails("postedDate", e.target.value)
                }
              />
            </div>
          </div>

          {/* Website */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("websiteInput")}</strong>
              </label>
              <input
                type="url"
                placeholder="Website"
                className="form-control"
                value={profDetails?.website}
                onChange={(e) => updateProfDetails("website", e.target.value)}
              />
            </div>
          </div>

          {/* Contact Name */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.contactName === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("contactNameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder="Contact Name"
                className="form-control"
                value={profDetails?.contactName}
                onChange={(e) =>
                  updateProfDetails("contactName", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.contactName === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("contactNameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Contact Email */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && profDetails?.contactEmail === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("contactEmailInput")}</strong>
              </label>
              <input
                type="email"
                placeholder="Contact Email"
                className="form-control"
                value={profDetails?.contactEmail}
                onChange={(e) =>
                  updateProfDetails("contactEmail", e.target.value)
                }
              />
            </div>
            {triggered && profDetails?.contactEmail === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("contactEmailInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          {/* Professional Profile Address */}

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalAddress")}</strong>
              </label>
              <StandaloneSearchBox onLoad={(ref) => (searchBoxRefProf.current = ref)} onPlacesChanged={handlePlacesChangedProf}>
                <input
                  type="text"
                  placeholder="Professional Profile Address"
                  className="form-control"
                  value={profDetails?.professionalProfileAddress}
                  onChange={(e) =>{
                    updateProfDetails("professionalProfileAddress", e.target.value);
                    updateProfDetails("professionalProfileCity", "");
                    updateProfDetails("professionalProfileRegion", "");
                    updateProfDetails("professionalProfilePostalCode", "");
                    updateProfDetails("professionalProfileCountry", "");
                   }
                  }
                />
              </StandaloneSearchBox>
            </div>
          </div>

          {/* Professional Profile City */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalcity")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile City"
                className="form-control"
                value={profDetails?.professionalProfileCity}
                onChange={(e) =>
                  updateProfDetails("professionalProfileCity", e.target.value)
                }
              />
            </div>
          </div>

          {/* Professional Profile Region */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalRegion")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Region"
                className="form-control"
                value={profDetails?.professionalProfileRegion}
                onChange={(e) =>
                  updateProfDetails("professionalProfileRegion", e.target.value)
                }
              />
            </div>
          </div>

          {/* Professional Profile Country */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalcountry")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Country"
                className="form-control"
                value={profDetails?.professionalProfileCountry}
                onChange={(e) =>
                  updateProfDetails(
                    "professionalProfileCountry",
                    e.target.value
                  )
                }
              />
            </div>
          </div>

          {/* Professional Profile Postal Code */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalpostal")}</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Postal Code"
                className="form-control"
                value={profDetails?.professionalProfilePostalCode}
                onChange={(e) =>
                  updateProfDetails(
                    "professionalProfilePostalCode",
                    e.target.value
                  )
                }
              />
            </div>
          </div>

          {/* Professional Profile Postal Code 2 */}
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hprofessionalpostal")} 2</strong>
              </label>
              <input
                type="text"
                placeholder="Professional Profile Postal Code 2"
                className="form-control"
                value={profDetails?.professionalProfilePostalCode2}
                onChange={(e) =>
                  updateProfDetails(
                    "professionalProfilePostalCode2",
                    e.target.value
                  )
                }
              />
            </div>
          </div>

          {/* Form Actions */}
          <div className="col-md-12 mb-5">
            {updateProf.cond ? (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => addProfHandler(updateProf.id)}
                >
                  {t("saveButton")}
                </button>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => addProfHandler(null)}
                >
                  {t("saveButton")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ProfessionalProfile;
